"use strict";

exports.__esModule = true;
var _ManualEventsContext = require("./ManualEventsContext");
Object.keys(_ManualEventsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ManualEventsContext[key]) return;
  exports[key] = _ManualEventsContext[key];
});